<template>
  <div
    class="d-flex flex-column flex-nowrap overflow-hidden section-carousel content-wrap"
    :class="[ throttleTouch ? 'pointer-events-none' : '', data.type.toLowerCase() + '-content-wrap', wrapClasses ]"
    @touchstart="startX = $event.changedTouches[0].pageX"
    @touchmove="handleMove($event.changedTouches[0].pageX, $event)"
    @touchend="handleMove($event.changedTouches[0].pageX, $event); handleEnd($event.changedTouches[0].pageX);"
  >
    <graph-header :ind-override="indOverride" :data="sub" :bg="bg"/>

    <component
      class="carousel-content"
      :is="data.type"
      :data="contentData"
      :has-bot="(bot !== '')"
      :ind-override="indOverride"
      @enable-bot="botActive = true"
      @disable-bot="botActive = false"
      @toggle-ind="toggleInd"
      @activated.once="demoActive = demoBot"
      ref="content"
    >

      <template v-if="data.type === 'Bar'" slot-scope="child">
        <template v-for="(slide, outerIdx) in data.slides">

          <bar-fragment
            class="in-carousel position-relative bar-wrap"
            :class="[{ looping: looping }, activeIdx === outerIdx ? 'on-active-slide' : '']"
            @transed="looping = false"
            v-for="(bar, idx) in slide.points"
            :key="idx.toString() + outerIdx"
            :target="bar.val[industry]"
            :active="child.active"
            :bg="bg"
            :idx="outerIdx + idx"
            :h="slide.height"
            :label="{ title: bar.title, pos: (idx === 1) ? 'top' : 'bottom', align: (idx === 1) ? 'right' : 'left'}"
            :percent-size="bar.fontSize"
            :style="{ zIndex: 10 - (idx + (outerIdx * 2)) }"
            :target-override="contentData.points[idx].val[industry]"
            :hide-percent="(outerIdx > 0)"
            :trans-x="Math.max(0, Math.min(data.slides.length - 1, (slideIdx + (-transAmt / 100)))) * child.barWidth * 2"
          />

        </template>
      </template>
    </component>

    <adobot
      :bg="bg"
      :active="botActive"
      :will-demo="demoBot"
      :demo-active="demoActive"
      @on="botOn"
      @off="botOff"
      v-if="bot"
    />

    <carousel-ctls
      :slides="data.slides"
      :max="maxIdx"
      :active="activeIdx"
      :trans-amt="(-slideIdx * 100 - 100) + transAmt"
      @arrowClick="handleArrow"
    />
  </div>
</template>

<script>
  import { TweenMax, Power2 } from 'gsap'
  import { dataTransTime } from '@/lib/consts'
  import CarouselCtls from '@/components/report/CarouselCtls'
  import ContentWrapMixin from '@/components/report/mixins/ContentWrapMixin'
  import BarFragment from '@/components/report/content/BarFragment'

  export default {
    name: 'Carousel',
    mixins: [ ContentWrapMixin ],
    data () {
      return {
        slideIdx: 0,
        transAmt: 0,
        startX: 0,
        throttleTouch: false,
        min: 50,
        clicked: false,
        looping: false
      }
    },
    computed: {
      maxIdx () { return this.data.slides.length - 1 },

      willTrans () { return this.clicked || (Math.abs( this.transAmt ) > this.min) },

      threshold () { return this.winW * 0.6 }
    },
    methods: {
      titleTweenEnd ( idx ) {
        this.throttleTouch = this.clicked = false
        this.looping = (idx === -1 || idx === (this.maxIdx + 1))
        this.slideIdx = idx === -1 ? this.maxIdx : idx === (this.maxIdx + 1) ? 0 : idx
        this.transAmt = 0
      },
      handleMove ( x, e ) {
        this.transAmt = Math.min( 0.75, Math.max( -0.75, (x - this.startX) / this.threshold ) ) * 100
        if ( Math.abs( this.transAmt ) > 10 ) e.preventDefault()
      },
      handleEnd ( x ) {
        let target = 0

        switch ( true ) {
          case (!this.willTrans):
            break

          case (this.activeIdx === 0 && x > this.startX):
            target = 1
            this.activeIdx = this.maxIdx
            break

          case (this.activeIdx === this.maxIdx && x < this.startX):
            target = -1
            this.activeIdx = 0
            break

          default:
            target = x < this.startX ? -1 : 1
            this.activeIdx -= target
        }
        let tf = this.clicked ? 1 : (this.min - Math.abs( Math.abs( this.transAmt ) - this.min )) / this.min
        this.throttleTouch = true

        TweenMax.to( this, (dataTransTime / 4) * tf, {
          transAmt: (target * 100),
          ease: Power2.easeOut,
          onComplete: () => this.titleTweenEnd( this.slideIdx - target )
        } )
      },
      handleArrow ( num ) {
        this.clicked = true
        this.handleEnd( this.startX + num )
      }
    },
    components: { CarouselCtls, BarFragment }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/global/the_goods";

  .section-carousel {
    &.bar-content-wrap {
      .ctls .title {
        margin : rem(10) 0;
      }

      .adobot-wrap {
        margin-top : rem(15);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/Carousel.vue